export const RATING_ICONS = {
  boat: "BOAT",
  smile: "SMILE",
}
